import { checkIsAreaCategory } from './common';

export const getPriceTranslationKey = (categoryId: string) => {
  const isArea = checkIsAreaCategory(categoryId);

  switch (true) {
    case isArea:
      return 'new_search.price_per_area';

    default:
      return 'new_search.price';
  }
};
